import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test210626 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 21/06/2026 Candidates(Sattahip)</h3>
      <br />
      <br />


        <div><Link to='/conduct-ratchadapornn'>1. AAT 7822  MS.RATCHADAPORN NONNUSAT(3KYU)---Trying for 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-napolp'>2. ATT  7910  MR.NAPOL PITAYAPAT(4KYU)---Trying for 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-asdawutc'>3. ATT  7925  LT.ASDAWUT CHODSAPTHAWEE(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-nirunc'>4. AAT 7783  LT.NIRUN CHANTAWARO(6KYU)---Trying for 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-sunyal'>5. AAT 7972  CPO1.SUNYA LAEID(6KYU)---Trying for 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-angieo'>6. ATT 7884  MS.ANGELICA JOSELINE OLSSON(7KYU)--Trying for 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-barbarab'>7. AAT 8027  MS.BARBARA BARZARKINA(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-panyasuphak'>8. AAT 8029  MS.PANYASUPHA KHEMARUT(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-zaidena'>9. AAT 8044  MR.ZAIDEN ANDERSSON(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-benjaminb'>10. AAT 8045  MR.BENJAMIN BROWN(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-tylerb'>11. AAT 8046  MR.TYLER BROWN(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-wyonab'>12. AAT 8047  MS. WYONA BROWN(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-kansinees'>13. AAT 8048  MS.KANSINEE SAIMONTREE(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-narns'>14. AAT 8049  MR.NARN SUDRAK(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-naruekarink'>15. AAT 8036  MR.NARUEKARIN KHEMARUT(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-jaiklal'>16. AAT 8067  MR.JAIKLA LORGUNPAI(WB)---Trying for 10KYU</Link></div>
        <br />


        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test210626;
